import { Button, Card, Input, Select, Space, Table } from 'antd';
import React, { useMemo, useState } from 'react';

import { CARD_BODY_STYLES, CARD_HEAD_STYLES } from '../../constants';
import { AddPointDistributionModal } from './components/AddPointDistributionModal';
import {
  DUMMY_POINT_DISTRIBUTIONS,
  DUMMY_SERVICE_OPTIONS,
  POINT_DISTRIBUTION_TABLE_COLUMNS,
} from './constants';
import styles from './index.module.scss';

export const PointDistribution = () => {
  const [showModal, setShowModal] = useState(false);
  const [memberKeyword, setMemberKeyword] = useState('');
  const [serviceName, setServiceName] = useState<string | undefined>(undefined);

  const closeModal = () => {
    setShowModal(false);
  };

  // TODO: 暫寫的邏輯，到時候要用真實的邏輯
  const tableDataSource = useMemo(() => {
    let dataSource = DUMMY_POINT_DISTRIBUTIONS;
    if (memberKeyword) {
      dataSource = dataSource.filter((distribution) => {
        return (
          distribution.member.includes(memberKeyword) ||
          distribution.phoneNumber.includes(memberKeyword)
        );
      });
    }
    if (serviceName) {
      dataSource = dataSource.filter((distribution) => {
        return distribution.service === serviceName;
      });
    }
    return dataSource;
  }, [memberKeyword, serviceName]);

  return (
    <>
      <Space direction="vertical" size="middle">
        <Button onClick={() => setShowModal(true)}>新增點數發放</Button>
        <Space size="middle">
          <div className={styles.filterContainer}>
            <p>會員：</p>
            <Input
              allowClear
              className={styles.filter}
              placeholder="輸入會員名稱或手機號碼"
              onChange={(event) => setMemberKeyword(event.target.value)}
            />
          </div>
          <div className={styles.filterContainer}>
            <p>服務：</p>
            <Select
              allowClear
              className={styles.filter}
              placeholder="請選擇服務"
              options={DUMMY_SERVICE_OPTIONS}
              onChange={(value) => setServiceName(value)}
            />
          </div>
        </Space>
        <Card
          title="點數發放"
          headStyle={CARD_HEAD_STYLES}
          bodyStyle={CARD_BODY_STYLES}
        >
          <Table
            bordered
            rowKey="_id" // TODO: 看rowKey到時候有沒有變，有變再改
            scroll={{ x: 'max-content' }}
            columns={POINT_DISTRIBUTION_TABLE_COLUMNS}
            // TODO: 假資料，記得改
            dataSource={tableDataSource}
          />
        </Card>
      </Space>
      <AddPointDistributionModal open={showModal} onClose={closeModal} />
    </>
  );
};
